(() => {
  if (window.__collectionCustomPriceSortLoaded) return;
  window.__collectionCustomPriceSortLoaded = true;

  const SORT_DIRECTIONS = {
    'price-ascending': 'asc',
    'price-descending': 'desc',
  };

  let sortQueued = false;

  function getSortDirection() {
    const sortBy = new URLSearchParams(window.location.search).get('sort_by');
    if (SORT_DIRECTIONS[sortBy]) return SORT_DIRECTIONS[sortBy];

    const selectedSort =
      document.querySelector('select[name="sort_by"]')?.value ||
      document.querySelector('input[name="sort_by"]:checked')?.value;

    return SORT_DIRECTIONS[selectedSort] || null;
  }

  function readItemPrice(item) {
    const pricedElement = item.querySelector('[data-card-sort-price]');
    if (!pricedElement) return null;

    const price = Number.parseInt(pricedElement.getAttribute('data-card-sort-price'), 10);
    return Number.isFinite(price) ? price : null;
  }

  function setAnimationOrder(item, order) {
    if (item && item.style) {
      item.style.setProperty('--animation-order', String(order));
    }
  }

  function revealSortedItem(item) {
    if (!item) return;

    item.classList.remove(
      'scroll-trigger',
      'animate--slide-in',
      'animate--fade-in',
      'scroll-trigger--offscreen'
    );
    item.classList.add('scroll-trigger--cancel');
    item.style.opacity = '1';
    item.style.transform = 'none';
  }

  function reinsertBanner(grid, banner, sortedItems) {
    if (!banner) return;

    const afterSixthProduct = sortedItems[5];

    if (afterSixthProduct && afterSixthProduct.nextSibling) {
      grid.insertBefore(banner, afterSixthProduct.nextSibling);
    } else {
      grid.appendChild(banner);
    }

    setAnimationOrder(banner, 7);
    revealSortedItem(banner);
  }

  function sortGrid() {
    sortQueued = false;

    const direction = getSortDirection();
    const grid = document.getElementById('product-grid');

    if (!direction || !grid || grid.dataset.customPriceSort !== 'true') return;

    const productItems = Array.from(grid.children).filter((item) =>
      item.matches('li:not(.collection-grid-banner-item)')
    );

    if (productItems.length < 2) return;

    const banner = Array.from(grid.children).find((item) =>
      item.matches('li.collection-grid-banner-item')
    );

    const sortedItems = productItems
      .map((item, index) => ({
        item,
        index,
        price: readItemPrice(item),
      }))
      .sort((a, b) => {
        if (a.price === null && b.price === null) return a.index - b.index;
        if (a.price === null) return 1;
        if (b.price === null) return -1;
        if (a.price === b.price) return a.index - b.index;

        return direction === 'asc' ? a.price - b.price : b.price - a.price;
      })
      .map(({ item }) => item);

    if (banner) banner.remove();

    sortedItems.forEach((item, index) => {
      setAnimationOrder(item, index + 1);
      revealSortedItem(item);
      grid.appendChild(item);
    });

    reinsertBanner(grid, banner, sortedItems);
  }

  function queueSort() {
    if (sortQueued) return;

    sortQueued = true;
    requestAnimationFrame(() => {
      requestAnimationFrame(sortGrid);
    });
  }

  document.addEventListener('DOMContentLoaded', queueSort);
  document.addEventListener('facets:updated', queueSort);
  document.addEventListener('pagination:loaded', queueSort);
  document.addEventListener('shopify:section:load', queueSort);
  window.addEventListener('popstate', queueSort);
})();
